export default __webpack_public_path__ + "static/media/207.20e733b5.png";